const pad = (value) => String(value).padStart(2, '0');
const toDateString = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

// Earliest allowed exam date: tomorrow in the user's local time, as YYYY-MM-DD.
export const getMinExamDate = (now = new Date()) =>
  toDateString(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1));

// Latest allowed exam date: 2 years from today in the user's local time, as YYYY-MM-DD.
export const getMaxExamDate = (now = new Date()) =>
  toDateString(new Date(now.getFullYear() + 2, now.getMonth(), now.getDate()));

export const EXAM_DATE_ERROR_MESSAGE = 'Exam date must be between tomorrow and 2 years from today.';
export const EXAM_DATE_INCOMPLETE_MESSAGE = 'Enter a full date.';

// Empty is allowed (field is optional). YYYY-MM-DD strings compare correctly as text.
export const isValidExamDate = (value, now = new Date()) =>
  !value || (/^\d{4}-\d{2}-\d{2}$/.test(value) && value >= getMinExamDate(now) && value <= getMaxExamDate(now));
